import { render, staticRenderFns } from "./goHome.vue?vue&type=template&id=1d7a812a&scoped=true&"
import script from "./goHome.js?vue&type=script&lang=js&"
export * from "./goHome.js?vue&type=script&lang=js&"
import style0 from "./goHome.less?vue&type=style&index=0&id=1d7a812a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7a812a",
  null
  
)

export default component.exports